import '@/styles/globals.css';
import '@/styles/tailwind.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { OpenAPI } from 'api-clients/monolith';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@/components/app';
import { ConfirmationProvider } from '@/components/base/confirmation';
import { ToasterProvider } from '@/components/base/toaster';
import { WxCopilotProvider } from '@/components/pages/wx-copilot-host/context';
import { AuthProvider } from '@/contexts/auth-context';
import { JobPostingProvider } from '@/contexts/job-posting-context';
import LanguageProvider from '@/i18n/language-provider';
import { domainMeta } from '@/utils/domain-meta';

OpenAPI.BASE = domainMeta.monolithOrigin;
OpenAPI.WITH_CREDENTIALS = true;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // No need to retry 404s. Other calls should retry once, not more.
      retry: (failureCount, error): boolean => {
        if (failureCount >= 1) return false;
        return !error.message?.includes('Not Found');
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <LanguageProvider>
          <ToasterProvider>
            <ConfirmationProvider>
              <AuthProvider>
                <JobPostingProvider>
                  <WxCopilotProvider>
                    <App />
                  </WxCopilotProvider>
                </JobPostingProvider>
              </AuthProvider>
            </ConfirmationProvider>
          </ToasterProvider>
        </LanguageProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
